__turbopack_context__.v({
  "blocksBackgroundColor": "ShopItem-module-scss-module__VpycFG__blocksBackgroundColor",
  "blocksFontColor": "ShopItem-module-scss-module__VpycFG__blocksFontColor",
  "item": "ShopItem-module-scss-module__VpycFG__item",
  "itemInfo": "ShopItem-module-scss-module__VpycFG__itemInfo",
  "secondaryNavBackgroundColor": "ShopItem-module-scss-module__VpycFG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ShopItem-module-scss-module__VpycFG__themeBackgroundColor",
  "themeFontColor": "ShopItem-module-scss-module__VpycFG__themeFontColor",
});
